import React from 'react';
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import './Specialities.css'; // Import the CSS file for styling

const Treatments = () => {
    const surgeries = [
        {
            title: "Minimally Invasive &amp; Robotic Surgery",
            description: "Robotic and minimally invasive surgery is used to perform complex surgeries with smaller incisions, reduced pain, and faster recovery times. This approach is applied in various cancer surgeries, including prostate, gynecologic, and gastrointestinal cancers.",
            link: "/learn-more"
        },
        {
            title: "Breast Cancer Surgery",
            description: "Breast cancer surgery aims to remove cancerous tissue from the breast while preserving as much healthy tissue as possible. Common procedures include lumpectomy, which involves removing the tumor and a small margin of surrounding tissue, and mastectomy, which involves removing the entire breast (either partially or totally).",
            link: "/learn-more"
        },
        {
            title: "Colon & Rectal Cancer Surgery",
            description: "Colon and rectal cancer surgery involves the removal of cancerous tumors from the colon or rectum. Common procedures include colectomy (removal of part or all of the colon), proctectomy (removal of part or all of the rectum), and colostomy, which creates an opening in the abdominal wall for waste elimination.",
            link: "/learn-more"
        },
        {
            title: "Head & Neck Cancer Surgery",
            description: "Head and neck cancer surgery involves the removal of tumors in the head and neck region, including the mouth, throat, and larynx. Common procedures include partial or total laryngectomy (removal of the voice box), mandibulectomy (removal of part of the jaw), and neck dissection (removal of lymph nodes in the neck).",
            link: "/learn-more"
        },
        {
            title: "Gynecologic Oncology Surgery",
            description: "Gynecologic oncology focuses on treating cancers of the female reproductive system, including ovarian, uterine, cervical, and vulvar cancers. Common procedures include hysterectomy (removal of the uterus), oophorectomy (removal of the ovaries), and debulking surgery, which involves removing as much tumor mass as possible and is often used in advanced ovarian cancer. ",
            link: "/learn-more"
        },
        {
            title: "Thoracic &amp; Abdominal Oncology Surgery",
            description: "Thoracic oncology deals with cancers of the chest, including lung cancer and esophageal cancer. Common procedures include lobectomy (removal of a lobe of the lung), pneumonectomy (removal of an entire lung), and esophagectomy (removal of part or all of the esophagus).",
            image: "/assets/images/tarunlogo.png",
            link: "/learn-more"
        },
    ];

    return (


        <Grid container spacing={2} justifyContent={"center"} display={"flex"} flex="1" sx={{height:"100%", marginTop:"3px"}}>
            {surgeries.map((surgery, index) => (
                <Grid key={index} item xs={12} sm={4}>
            <Card item xs={12} sm={4}
                        sx={{
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: "100%",
                            justifyContent: 'center',
                            padding:"10px"
                        }}
                    >
                         <Typography sx={{fontSize:"20px", fontWeight:"bold"}}>{surgery.title}</Typography>
                        <CardContent>
                        {/* <img
            src="assets/images/.jpg"
            alt={surgery.title}
            style={{ width: "100%", height: "auto", borderRadius: "8px", marginBottom: "5px" }}
          /> */}
                        </CardContent>
                       
                        <Typography>{surgery.description}</Typography>
                        <a href={surgery.link} className="learn-more-link">Learn more →</a>
                    </Card>
                </Grid>

            ))}
        </Grid>
    
    );
};

export default Treatments;

